import React from "react";
import Framework from "@beardeddevops/react.framework";
import {Types} from "components";
import moment from "moment";
import {Button} from "reactstrap";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import UserRoles from "../../constants/UserRoles";

/**
 * @property {Help_Desks_Object} state
 * @property {object} model
 * @property {Help_Desks_Properties} model.properties
 *
 */

class HelpDeskDisplay extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Help_Desks._name);
		this.state.filterDate = 0;
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot)
		if (typeof(this.props.setTicket) === 'function' && prevState.ticket !== this.state.ticket)
		{
			this.props.setTicket(this.state.ticket);
		}
	}

	// Not the ideal way to handle this, can put it into a single function, leaving it like this in case there is more complicated stuff
	// needed in the future.
	resolve = (event) => {
		this.state.resolved = true;
		this.redirect = '/helpdesks'
		this.handleSubmit(event, true);
	}
	reopen = (event) => {
		this.state.resolved = false;
		this.handleSubmit(event, true);
	}

	render() {

		/**
		 * @param {Help_Desks_Properties} data
		 */
		let {properties} = this.model;

		/**
		 * @type {Help_Desks_Object} object
		 */
		let object = this.state;
		let disabled = !(this.props.rootState.roles.includes(UserRoles.HelpDesk) || this.props.rootState.user === object.users_related_by_creator.pkey || !object.resolved)

		return (
			<Card>
				<CardContent>
					<fieldset disabled={disabled}>
						<div className={'row'}>
							<div className={'col'}>
								<div className="form-group">
									{object.users_related_by_creator.pkey && <Framework.Elements.Select //Have to do it this way to avoid a toast throwing before state is set.
										objectKey={this.state.filterDate.toString()}
										shouldLoad={true}
										update={this.handleSelectPropertyUpdate}
										property={properties.ticket}
										value={object.ticket}
										error={object.ticket_error}
										object={object.tickets}
										nullable={true}
										limit={null}
										requestOverride={'GET_FE_TICKETS'}
										parent={this.props.rootState.user ?? object.users_related_by_creator.pkey}
										text={'pkey'}
										label={'Attached Ticket'}
									/>}
								</div>
							</div>
							<div className={'col'}>
								<div className="form-group">
									<Framework.Elements.Select
										shouldLoad={true}
										update={this.handleSelectPropertyUpdate}
										property={properties.user_assigned}
										value={object.user_assigned ?? null}
										error={object.user_assigned_error}
										object={object.users}
										nullable={true}
										limit={null}
										text={'name_first&name_last'}
										filter={(user) => {
											let isHelpDesk = false;
											user.users_roless?.map((user_role) => {
												if (user_role.role === 6)
												{
													isHelpDesk = true;
												}
											})
											return isHelpDesk ? user : null;
										}}
										label={'Assigned Help Desk Agent'}
										disabled={disabled || !this.props.rootState.roles.includes(UserRoles.HelpDesk)}
									/>
								</div>
							</div>
						</div>
						<div className={'row'}>
							<div className={'col-12'}>
								<div className="form-group">
									<Framework.Elements.TextField
										property={properties.notes}
										value={object.notes}
										error={object.notes_error}
										update={this.handleTextFieldPropertyUpdate}
										multiline={4}
									/>
								</div>
							</div>
						</div>
						<i className="fa fa-user"/>&nbsp;&nbsp;Created By {object.users_related_by_creator.name_first} {object.users_related_by_creator.name_last} on&nbsp;
						{moment(object.created).format('MM/DD/YY')}
						&nbsp;at {moment(object.created).format('h:mm a')}
					</fieldset>
				</CardContent>
				<CardActions style={{justifyContent: "flex-end", padding: "14px", flexWrap: "wrap"}}>
					<Button color="secondary" onClick={() => (this.props.history.goBack())}> Back </Button>
					{this.state.resolved ? <Button color="primary" onClick={this.reopen}> Re-open </Button> :
						<>
							<Button color="danger" onClick={this.resolve}> Resolve </Button>
							<Button color="primary" onClick={this.handleSubmit}> Update </Button>
						</>}
				</CardActions>
			</Card>
		)
	}
}

export default Framework.Components.withRootState(HelpDeskDisplay);
